<template>
  <tr class="no-border">
    <!-- eslint-disable vue/no-v-html -->
    <td v-html="lineItem.attributes.description" />
    <td>
      {{ lineItem.attributes.specifications }}
      <p class="alert-text" v-if="lineItem.attributes.margin_code == 'Excess'">
        Clearance
        <br />
        <a class="alert-text" href="/shop/discounted_products">View more Clearance items here</a>
      </p>
      <p class="alert-text" v-if="lineItem.attributes.size_up_sku != null">
        <br />
        <strong>
          Note: We do not have your requested item in stock. We do have the next size up. We have added this to your order, feel free to remove it if it does not fulfill your requirements.
        </strong>
        <span v-if="lineItem.attributes.uom == 'lbs'">
          <br />
            As you have selected lbs, we have calculated the equivalent quantity in the new size.
          </span>
        <br />
        Original Item: {{ lineItem.attributes.size_up_sku }}
      </p>
    </td>
    <td v-if="lineItem.attributes.override_price == null">
      <input
        v-model.number="lineItem.attributes.quantity"
        size="3"
        @keyup="
          $emit('update-quantity', lineItem.id, lineItem.attributes.quantity)
        "
        id="line_item_quantity_input"
      />
      &nbsp{{ lineItem.attributes.uom }}
    </td>
    <td v-if="lineItem.attributes.override_price">
      {{ lineItem.attributes.quantity }} {{ lineItem.attributes.uom }}
    </td>
    <td v-if="lineItem.attributes.override_price == null" >
      {{ lineItem.attributes.unit_price }} / {{ lineItem.attributes.uom }}
    </td>
    <td v-if="lineItem.attributes.override_price" >
      ${{ lineItem.attributes.override_price }} / {{ lineItem.attributes.uom }}
    </td>
    <td v-if="lineItem.attributes.override_price == null" >
      {{ lineItem.attributes.subtotal }}
    </td>
    <td v-if="lineItem.attributes.override_price" >
      {{ lineItem.attributes.override_subtotal }}
    </td>
    <td class="no-border">
      <button
        title="Remove item from Materials List"
        type="button"
        class="button alert rounded"
        @click="$emit('delete-line-item')"
      >
        &#10006;
      </button>
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    lineItem: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped>
button {
  margin: 0;
}

.gray {
  background-color: #757575;
  color: white;
  line-height: inherit;
  min-width: 155px;
  text-transform: none;
}

.alert {
  color: white;
  font-size: 20px;
  height: 25px;
  line-height: 0;
  min-width: 25px;
  padding-left: 1px;
  text-transform: none;
}

.rounded {
  border-radius: 5px;
}

.no-border {
  border: none;
}

tbody td {
  border: 1px solid black;
  padding: 5px;
}

.alert-text {
  color: red;
}
</style>
